module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/registration/payment-failure/payment-failure.component.css
// module id = ./src/app/registration/payment-failure/payment-failure.component.css
// module chunks = main